<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">Add Configuration</div>

  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <button
        class="nav-link active"
        id="nav-pkgConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#packageConfig"
        type="button"
        role="tab"
        aria-controls="packageConfig"
        aria-selected="true"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>Package Configuration
      </button>

      <button
        class="nav-link"
        id="nav-rangeConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#rangeConfig"
        type="button"
        role="tab"
        aria-controls="rangeConfig"
        aria-selected="false"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>Range
      </button>

      <button
      class="nav-link"
      id="nav-coupanConfig-tab"
      data-bs-toggle="tab"
      data-bs-target="#coupanConfig"
      type="button"
      role="tab"
      aria-controls="coupanConfig"
      aria-selected="false"
    >
      <i class="fa fa-plus" aria-hidden="true"></i>Coupan 
    </button>

      <button
        class="nav-link"
        id="nav-packerMoverConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#packerMoverConfig"
        type="button"
        role="tab"
        aria-controls="packerMoverConfig"
        aria-selected="false"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>Packers Movers
        Configuration
      </button>

      <button
        class="nav-link"
        id="nav-applicationConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#applicationConfig"
        type="button"
        role="tab"
        aria-controls="applicationConfig"
        aria-selected="false"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>Application Configuration
      </button>

      <button
        class="nav-link"
        id="nav-qrConfig-tab"
        data-bs-toggle="tab"
        data-bs-target="#qrConfig"
        type="button"
        role="tab"
        aria-controls="qrConfig"
        aria-selected="false"
      >
        <i class="fa fa-plus" aria-hidden="true"></i>QR Configuration
      </button>
    </div>
  </nav>

  <!-- Tabs -->
  <div class="tab-content" id="nav-tabContent">
    <!-- package Config Tab -->
    <div
      class="tab-pane fade show active"
      id="packageConfig"
      role="tabpanel"
      aria-labelledby="packageConfig-tab"
    >
      <div class="row">
        <div class="col-md-12">
          <div>
            <div class="card-body">
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <h5 class="font-weight-B">
                    <i class="fa fa-plus"></i> Add Package Configuration
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for=""
                    >Helper Amount <span>( <i class="fa fa-inr"></i> )</span> :
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="helpersBasicAmount"
                    class="form-control"
                    placeholder="Helper Amount"
                  />
                </div>
                <div class="col-md-4">
                  <label for=""
                    >Helper GST (<span class="font-weight-B">%</span>):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="helperGST"
                    class="form-control"
                    placeholder="Helper GST"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for=""
                    >Coupon Basic Amount
                    <span>( <i class="fa fa-inr"></i> )</span>:
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="couponBasicAmount"
                    class="form-control"
                    placeholder="Coupon Basic Amount"
                  />
                </div>
                <div class="col-md-4">
                  <label for=""
                    >Trip Fare GST (<span class="font-weight-B">%</span>):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="tripFareGST"
                    class="form-control"
                    placeholder="Trip Fare GST"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for=""
                    >Commission Fee <span>( <i class="fa fa-inr"></i> )</span>:
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="commissionFee"
                    placeholder="Commission Fee"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label for=""
                    >Commission Fee GST (<span class="font-weight-B">%</span>):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="commissionFeeGST"
                    class="form-control"
                    placeholder="Commission Fee GST"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for=""
                    >Convenience Fee <span>( <i class="fa fa-inr"></i> )</span>:
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="convenienceFee"
                    placeholder="Convenience Fee"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label for=""
                    >Convenience Fee GST (<span class="font-weight-B">%</span>):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="convenienceFeeGST"
                    class="form-control"
                    placeholder="Commission Fee GST"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for=""
                    >Minimum Distance For Trip (
                    <span class="font-weight-B">KM</span> ):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="minimumDistanceForTrip"
                    placeholder="Minimum Distance For Trip (KM)"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  <label for=""
                    >Distance for Notification (
                    <span class="font-weight-B">KM</span> ):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="distanceForNotification"
                    class="form-control"
                    placeholder="Distance for Notification (KM)"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <label for=""
                    >Helper TDS (<span class="font-weight-B">%</span>):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="helperTDS"
                    class="form-control"
                    placeholder="Helper TDS"
                  />
                </div>
                <div class="col-md-4">
                  <label for=""
                    >Driver TDS (<span class="font-weight-B">%</span>):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="driverTDS"
                    class="form-control"
                    placeholder="Driver TDS"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button
                    (click)="addPackageConfiguration()"
                    class="btn btn-primary btn-lg btn-block"
                    [disabled]="
                      helpersBasicAmount === null ||
                      helpersBasicAmount === undefined ||
                      helperTDS === null ||
                      helperTDS === undefined ||
                      driverTDS === null ||
                      driverTDS === undefined ||
                      helperGST === null ||
                      helperGST === undefined ||
                      couponBasicAmount === null ||
                      couponBasicAmount === undefined ||
                      tripFareGST === null ||
                      tripFareGST === undefined ||
                      commissionFee === null ||
                      commissionFee === undefined ||
                      commissionFeeGST === null ||
                      commissionFeeGST === undefined ||
                      convenienceFee === null ||
                      convenienceFee === undefined ||
                      convenienceFeeGST === null ||
                      convenienceFeeGST === undefined ||
                      minimumDistanceForTrip === null ||
                      minimumDistanceForTrip === undefined ||
                      distanceForNotification === null ||
                      distanceForNotification === undefined
                    "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Range Config Tab -->
    <div
      class="tab-pane fade"
      id="rangeConfig"
      role="tabpanel"
      aria-labelledby="rangeConfig-tab"
    >
      <div class="row">
        <div class="col-md-12">
          <div
            class="main-card mb-3 card align-items-center"
            style="border: none"
          >
            <div class="card-body">
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <h5 class="font-weight-B">
                    <i class="fa fa-plus"></i> Add New Range
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Minimum Distance (KM) : </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="minimumDistance"
                    class="form-control"
                    placeholder="Enter Minimum Distance"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Maximum Distance (KM) : </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="maximumDistance"
                    class="form-control"
                    placeholder="Enter Maximum Distance"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>
              <!-- Validation error message -->
              <div
                class="row"
                *ngIf="
                  minimumDistance >= maximumDistance &&
                  maximumDistance !== undefined &&
                  minimumDistance !== undefined
                "
              >
                <div class="col-md-12">
                  <p class="text-danger small">
                    Max Distance Must greater than Min Distance.
                  </p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Range : </label>
                  <input
                    type="text"
                    [(ngModel)]="range"
                    class="form-control"
                    placeholder="E.g: Short / Medium / Long"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button
                    (click)="addNewRange()"
                    class="btn btn-primary btn-lg btn-block"
                    [disabled]="
                      minimumDistance === null ||
                      minimumDistance === undefined ||
                      maximumDistance === null ||
                      maximumDistance === undefined ||
                      minimumDistance >= maximumDistance ||
                      !range
                    "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- Coupan Config Tab -->
      <div
      class="tab-pane fade"
      id="coupanConfig"
      role="tabpanel"
      aria-labelledby="coupanConfig-tab"
    >
      <div class="row">
        <div class="col-md-12">
          <div
            class="main-card mb-3 card align-items-center"
            style="border: none"
          >
            <div class="card-body">
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <h5 class="font-weight-B">
                    <i class="fa fa-plus"></i> Add New Coupan
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Coupan Code : </label>
                  <input
                    type="text"
                    min="0"
                    [(ngModel)]="coupanCode"
                    class="form-control"
                    placeholder="Enter Coupan Code"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Amount : </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="coupanAmount"
                    class="form-control"
                    placeholder="Enter Coupan Amount"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>
              <!-- Validation error message -->
              <!-- <div
                class="row"
                *ngIf="
                  minimumDistance >= maximumDistance &&
                  maximumDistance !== undefined &&
                  minimumDistance !== undefined
                "
              >
                <div class="col-md-12">
                  <p class="text-danger small">
                    Max Distance Must greater than Min Distance.
                  </p>
                </div>
              </div> -->
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Expiry : </label>
                  <input
                    type="date"
                    [min]="minDate"
                    [(ngModel)]="coupanExpiry"
                    class="form-control"
                    placeholder="Expiry"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button
                    (click)="addNewCoupan()"
                    class="btn btn-primary btn-lg btn-block"
                    [disabled]="
                      coupanCode ==='' ||
                      coupanAmount === null ||
                      coupanAmount === undefined ||
                      !coupanExpiry 
                    "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Packers Movers Config Tab -->
    <div
      class="tab-pane fade"
      id="packerMoverConfig"
      role="tabpanel"
      aria-labelledby="packerMoverConfig-tab"
    >
      <div class="row">
        <div class="col-md-12">
          <div
            class="main-card mb-3 card align-items-center"
            style="border: none"
          >
            <div class="card-body">
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <h5 class="font-weight-B">
                    <i class="fa fa-plus"></i> Add Packers Movers Configuration
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for=""
                    >Packers Movers Lite Amount
                    <span>( <i class="fa fa-inr"></i> )</span> :
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="packersMoversLitePrice"
                    class="form-control"
                    placeholder="Packers Movers Lite Amount"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for=""
                    >Packers Movers Standard Amount (<span>
                      <i class="fa fa-inr"></i> </span
                    >):
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="packersMoversLiteStandard"
                    class="form-control"
                    placeholder="Packers Movers Standard Amount "
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for=""
                    >Packers Movers Premium Amount
                    <span>( <i class="fa fa-inr"></i> )</span>:
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="packersMoversLitePremium"
                    class="form-control"
                    placeholder="Packers Movers Premium Amount"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for=""
                    >Distance For Notification <span>( KM )</span>:
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="distanceForNotificationPM"
                    class="form-control"
                    placeholder="Distance For Notification"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button
                    (click)="addPackerMoverConfiguration()"
                    class="btn btn-primary btn-lg btn-block"
                    [disabled]="
                      packersMoversLitePrice === null ||
                      packersMoversLitePrice === undefined ||
                      packersMoversLiteStandard === null ||
                      packersMoversLiteStandard === undefined ||
                      packersMoversLitePremium === null ||
                      packersMoversLitePremium === undefined ||
                      distanceForNotificationPM === null ||
                      distanceForNotificationPM === undefined
                    "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Application Config Tab -->
    <div
      class="tab-pane fade"
      id="applicationConfig"
      role="tabpanel"
      aria-labelledby="applicationConfig-tab"
    >
      <div class="row">
        <div class="col-md-12">
          <div
            class="main-card mb-3 card align-items-center"
            style="border: none"
          >
            <div class="card-body">
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <h5 class="font-weight-B">
                    <i class="fa fa-plus"></i> Add Application Configuration
                  </h5>
                </div>
              </div>
              
              <div class="row">
                <!-- <div class="col-md-2"></div> -->
                <div class="col-md-6">
                  <label for=""
                    >Mobile No Contact Us <i class="fa fa-phone-square"></i> :
                  </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="mobileNoContactUs"
                    class="form-control"
                    placeholder="Mobile No Contact Us "
                  />
                </div>
                <div class="col-md-6">
                  <label for=""
                    >Email Id Help
                    <span> <i class="fa fa-envelope"></i> </span> :
                  </label>
                  <input
                    type="email"
                    [(ngModel)]="emailIdHelp"
                    class="form-control"
                    placeholder="Email Id Help "
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <!-- <div class="col-md-2"></div> -->
                <div class="col-md-6">
                  <label for="">Splash Screen Time (<span>Sec</span>) : </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="splashScreenTime"
                    class="form-control"
                    placeholder="Splash Screen Time"
                  />
                </div>
                <div class="col-md-6">
                  <label for=""
                    >Helpline Number <i class="fa fa-phone-square"></i>:
                  </label>
                  <input
                    type="number"
                    min="0"
                    max="10"
                    [(ngModel)]="helpLineNo"
                    class="form-control"
                    placeholder="Helpline Number"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <!-- <div class="col-md-2"></div> -->
                <div class="col-md-6">
                  <label for="">User App Version : </label>
                  <input
                    type="text"
                    [(ngModel)]="userAppVersion"
                    class="form-control"
                    placeholder="User App Version"
                  />
                </div>
                <div class="col-md-6">
                  <label for="">Driver App Version : </label>
                  <input
                    type="text"
                    [(ngModel)]="driverAppVersion"
                    class="form-control"
                    placeholder="Driver App Version"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <!-- <div class="col-md-2"></div> -->
                <div class="col-md-6">
                  <label for="">User App Updates : </label>
                  <input
                    type="text"
                    [(ngModel)]="userAppUpdates"
                    class="form-control"
                    placeholder="User App Version"
                  />
                </div>
                <div class="col-md-6">
                  <label for="">Driver App Updates : </label>
                  <input
                    type="text"
                    [(ngModel)]="driverAppUpdates"
                    class="form-control"
                    placeholder="Driver App Updates"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <!-- <div class="col-md-2"></div> -->
                <div class="col-md-6">
                  <label for="">Driver Wallet Min Amount : </label>
                  <input
                    type="number"
                    min="0"
                    [(ngModel)]="driverWalletMinimumAmount"
                    class="form-control"
                    placeholder="Driver Wallet Minimum Amount"
                  />
                </div>
                <!-- <div class="col-md-6">
                  <label for="">Driver App Updates : </label>
                  <input
                    type="text"
                    [(ngModel)]="driverAppUpdates"
                    class="form-control"
                    placeholder="Driver App Updates"
                  />
                </div> -->
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <!-- <div class="col-md-2"></div> -->
                <div class="col-md-6">
                  <label for=""> Bill Details Visibility :  </label> <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      (ngModelChange)="billdetailsVisible($event)"
                      [(ngModel)]="isBillDetails"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-md-6">
                  <label for=""> Helper Active :  </label> <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      (ngModelChange)="heplerActive($event)"
                      [(ngModel)]="isHelperActive"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-md-2"></div>
              </div>

              <!-- <div class="row">
                <div class="col-md-6">
                  <label for=""> Online Payment Method:  </label> <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      (ngModelChange)="OnlinePay($event)"
                      [(ngModel)]="isOnlinePay"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-md-6">
                  <label for=""> Pay On Delivery:  </label> <br />
                  <label class="switch">
                    <input
                      type="checkbox"
                      (ngModelChange)="payOnDel($event)"
                      [(ngModel)]="isPayOnDelivery"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-md-2"></div>
              </div> -->
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button
                    class="btn btn-primary btn-lg btn-block"
                    (click)="addApplicationConfiguration()"
                    [disabled]="
                      !mobileNoContactUs ||
                      !emailIdHelp ||
                      splashScreenTime === null ||
                      splashScreenTime === undefined ||
                      !helpLineNo || 
                      driverWalletMinimumAmount===null ||
                      driverWalletMinimumAmount===undefined
                    "
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- QR Config Tab -->
    <div
      class="tab-pane fade"
      id="qrConfig"
      role="tabpanel"
      aria-labelledby="qrConfig-tab"
    >
      <div class="row">
        <div class="col-md-12">
          <div
            class="main-card mb-3 card align-items-center"
            style="border: none"
          >
            <div class="card-body">
              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <h5 class="font-weight-B">
                    <i class="fa fa-plus"></i> Add QR Configuration
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">Mode : </label>
                  <input
                    type="text"
                    [(ngModel)]="mode"
                    class="form-control"
                    placeholder="Mode "
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">MC : </label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="MC"
                    [(ngModel)]="mc"
                  />
                </div>
                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">QR Medium : </label>
                  <input
                    type="text"
                    [(ngModel)]="qrMedium"
                    class="form-control"
                    placeholder="QR Medium"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">TN : </label>
                  <input
                    type="text"
                    [(ngModel)]="tn"
                    class="form-control"
                    placeholder="TN"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">PN : </label>
                  <input
                    type="text"
                    [(ngModel)]="pn"
                    class="form-control"
                    placeholder="PN"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-12">
                  <label for="">PA : </label>
                  <input
                    type="text"
                    [(ngModel)]="pa"
                    class="form-control"
                    placeholder="PA"
                  />
                </div>

                <div class="col-md-2"></div>
              </div>

              <div class="row mt-3 mb-3 text-center">
                <div class="col-md-12">
                  <button
                    class="btn btn-primary btn-lg btn-block"
                    (click)="addQRConfiguration()"
                    [disabled]="!mode || !mc || !qrMedium || !tn || !pn || !pa"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
